import { render, staticRenderFns } from "./TNomicsAbundance.vue?vue&type=template&id=22d664d1"
import script from "./TNomicsAbundance.vue?vue&type=script&lang=js"
export * from "./TNomicsAbundance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports